import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import milestoneService from '../../../services/milestoneService'
import { 
  Target,
  CheckCircle,
  Clock,
  AlertTriangle,
  TrendingUp,
  Calendar,
  FileText,
  Award,
  BarChart3,
  Users
} from 'lucide-react'

const Milestones = () => {
  const navigate = useNavigate()
  const [dashboardData, setDashboardData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDashboardData()
  }, [])

  const loadDashboardData = async () => {
    try {
      setLoading(true)
      const response = await milestoneService.getMilestoneStats()
      if (response.success) {
        setDashboardData(response.data)
      } else {
        if (!response._errorHandled) {
          toast.error(response.message || 'Failed to load dashboard data')
        }
      }
    } catch (error) {
      console.error('Error loading milestones dashboard data:', error)
      if (!error._errorHandled) {
        if (error.response) {
          toast.error(error.response.data?.message || 'Failed to load dashboard data')
        } else if (!error.request) {
          toast.error('Failed to load dashboard data')
        }
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="sales-dashboard">
      {/* Page Header */}
      <div className="page-header" style={{textAlign: 'left'}}>
        <div className="page-title" style={{textAlign: 'left', alignItems: 'flex-start'}}>
          <h1 style={{textAlign: 'left', margin: '0 0 4px 0'}}>Milestones</h1>
          <p style={{textAlign: 'left', margin: 0}}>Track project milestones and deliverables</p>
        </div>
      </div>

      {/* Key Metrics Grid */}
      <div className="dashboard-metrics-grid">
        <div className="metric-card revenue">
          <div className="metric-header">
            <div className="metric-icon">
              <Target size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+12%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.totalMilestones || 0)}
          </div>
          <div className="metric-title">Total Milestones</div>
          <div className="metric-subtitle">All milestones</div>
        </div>

        <div className="metric-card customers">
          <div className="metric-header">
            <div className="metric-icon">
              <CheckCircle size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+8%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.completed || 0)}
          </div>
          <div className="metric-title">Completed</div>
          <div className="metric-subtitle">This month</div>
        </div>

        <div className="metric-card churn">
          <div className="metric-header">
            <div className="metric-icon">
              <Clock size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+5%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.inProgress || 0)}
          </div>
          <div className="metric-title">In Progress</div>
          <div className="metric-subtitle">Currently active</div>
        </div>

        <div className="metric-card burn">
          <div className="metric-header">
            <div className="metric-icon">
              <AlertTriangle size={16} />
            </div>
            <div className="metric-trend positive">
              <TrendingUp size={12} />
              <span>+3%</span>
            </div>
          </div>
          <div className="metric-value">
            {loading ? '...' : (dashboardData?.delayed || 0)}
          </div>
          <div className="metric-title">Delayed</div>
          <div className="metric-subtitle">Need attention</div>
        </div>
      </div>

      {/* Transactions Grid */}
      <div className="projects-transactions-content" style={{ marginTop: '24px' }}>
        <div className="projects-transactions-header">
          <h2>Milestone Management</h2>
          <p>Track and manage all project milestones</p>
        </div>
        <div className="projects-transactions-grid">
          <div 
            className="projects-transaction-card" 
            onClick={() => navigate('/projects/milestones/list')} 
            style={{ cursor: 'pointer' }}
          >
            <div className="projects-transaction-icon">
              <Target size={24} />
            </div>
            <div className="projects-transaction-content">
              <h3>Milestone List</h3>
              <p>Create, view, and manage all milestones</p>
              <div className="projects-transaction-count">
                {loading ? '...' : `${dashboardData?.totalMilestones || 0} Total`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Milestones

